import { jsx } from "panel";
import { QueryBlockEl } from "common/query-builder/query-block/panel";
export function template() {
  var _a, _b, _c, _d;
  const { addingBlock, prefixRenderer, stagingSelected } = this.state;
  const selected = stagingSelected || this.attr(`selected`);
  const MultiBlockItem = ({ selection, idx }) => {
    return /* @__PURE__ */ jsx(null, null, prefixRenderer ? /* @__PURE__ */ jsx("div", {
      sel: ".mp-query-multi-block-prefix"
    }, prefixRenderer(idx, selection)) : null, /* @__PURE__ */ jsx("div", {
      sel: ".mp-query-multi-block-item",
      key: JSON.stringify(selection)
    }, /* @__PURE__ */ jsx(QueryBlockEl, {
      ...this.helpers.getQueryBlockProps(),
      elref: "queryBlock",
      prefixLabel: this.attr(idx === 0 ? `first-block-prefix` : `block-prefix`),
      removable: true,
      selected: selection,
      onRemove: () => this.helpers.removeSelection(selection),
      onSelect: (ev) => this.helpers.modifySelection(idx, ev),
      onTrack: this.helpers.preventTracking
    })));
  };
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-multi-block",
    class: { [`${this.attr(`layout`)}-layout`]: true }
  }, selected.map((selection, idx) => /* @__PURE__ */ jsx(MultiBlockItem, {
    selection,
    idx
  })), !this.attr(`adding-disabled`) && this.helpers.canAddMore() ? /* @__PURE__ */ jsx(null, null, prefixRenderer ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-multi-block-prefix"
  }, prefixRenderer(selected.length, null)) : null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-multi-block-item",
    key: "new-block-item"
  }, /* @__PURE__ */ jsx(QueryBlockEl, {
    ...this.helpers.getQueryBlockProps(),
    selectorIcon: (_a = this.attr(`button-icon`)) != null ? _a : void 0,
    selectorType: (_b = this.attr(`button-selector-type`)) != null ? _b : void 0,
    theme: (_c = this.attr(`button-selector-theme`)) != null ? _c : void 0,
    label: this.helpers.buttonText(),
    inputOnly: true,
    tooltip: (_d = this.attr(`tooltip`)) != null ? _d : void 0,
    open: this.attr(`button-open`) || addingBlock,
    elref: "addBlock",
    onSelect: this.helpers.commitNewBlock,
    onTrack: this.helpers.preventTracking,
    onOpen: () => this.helpers.setAddingBlock(true),
    onClose: this.helpers.onAddItemBlockClose,
    preventClose: this.attr(`prevent-close`)
  }))) : null);
}
